import { Box, Button, Card, CardContent, Paper, Stack } from "@mui/material";
import { ReactElement, useContext } from "react";
import { PageContext } from "../App/Context/PageContext";
import { useLocalStorage } from "react-use";
import { Resource } from "../utils";
import { Page } from "../../api";
import { ActionType, AppContext } from "@cdv/jazz-ui";
import { useNavigate } from "react-router";
import AppBar from "../ui/AppBar";

export default function Content(): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  const { pages } = useContext(PageContext);

  return (
    <Stack
      sx={{ justifyContent: "center", alignItems: "center", minHeight: "92vh", mt: "0 !important" }}
      spacing={2}
    >
      {pages
        ?.filter((page) => page.parrent === null)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((page, i) => (
          <Stack key={i} spacing={2} sx={{ alignItems: "center" }}>
            {page.image?.id && (
              <img src={"/obrazky/" + page.image.id} style={{ minHeight: "125px" }} />
            )}
            <Button
              variant="contained"
              size="large"
              sx={{ width: "211px" }}
              onClick={() => navigate(getUrl(Resource.Page, ActionType.SHOW, { id: page.id }))}
            >
              {page.name}
            </Button>
          </Stack>
        ))}
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <img src="/assets/05_ilustr_test-stres.svg" style={{ height: "159px" }} />
        <Button
          size="large"
          sx={{ width: "211px" }}
          variant="contained"
          onClick={() => navigate(getUrl(Resource.TestDefinition, ActionType.INDEX))}
        >
          Otestuj se!{" "}
        </Button>
      </Stack>
    </Stack>
  );
}
